import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50c98066"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "themeModal"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" テーマを")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("変更")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, "(", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rt", null, "へんこう", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rp", null, ")", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("する ")
const _hoisted_8 = { class: "themeSelect__lists" }
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "themeSelect__img_inner" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "themeSelect__button_inner" }, "えらぶ", -1))

import { ref, withDefaults } from 'vue'

import { usePortalStore } from '@/store'

import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'
import SlotModal from '@/components/SlotModal/SlotModal.vue'
import ApiHelper from '@/helpers/ApiHelper'
import * as ApiIF from '@/models/ApiIF'
import StoreHelper from '@/helpers/StoreHelper'
import { useHandleError } from '@/composables/useHandleError'

type Props = {
  open?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSelect',
  props: {
    open: { type: Boolean, default: false }
  },
  emits: ['close', 'update:theme'],
  setup(__props: any, { emit }) {

const props = __props as { open: boolean }

/**
 * ThemeSelect.
 *
 * テーマ選択モーダル.
 */

const { handleErrors } = useHandleError()



const themes = Object.freeze([
  { id: 1, src: '1.jpg' },
  { id: 31, src: '31.jpg' },
  { id: 32, src: '32.jpg' },
  { id: 36, src: '36.jpg' },
  { id: 33, src: '33.jpg' },
  { id: 34, src: '34.jpg' },
  { id: 35, src: '35.jpg' },
  { id: 29, src: '29.jpg' },
  { id: 37, src: '37.jpg' },
  { id: 27, src: '27.jpg' },
  { id: 4, src: '4.jpg' },
  { id: 5, src: '5.jpg' },
  { id: 26, src: '26.jpg' },
  { id: 30, src: '30.jpg' },
  { id: 3, src: '3.jpg' },
  { id: 2, src: '2.jpg' },
  { id: 28, src: '28.jpg' },
  { id: 42, src: '42.jpg' },
  { id: 43, src: '43.jpg' },
  { id: 44, src: '44.jpg' },
  { id: 45, src: '45.jpg' },
  { id: 46, src: '46.jpg' },
  { id: 47, src: '47.jpg' },
  { id: 48, src: '48.jpg' },
  { id: 38, src: '38.jpg' },
  { id: 39, src: '39.jpg' },
  { id: 40, src: '40.jpg' },
  { id: 41, src: '41.jpg' },
  { id: 22, src: '22.jpg' },
  { id: 23, src: '23.jpg' },
  { id: 24, src: '24.jpg' },
  { id: 25, src: '25.jpg' },
  { id: 6, src: '6.jpg' },
  { id: 7, src: '7.jpg' },
  { id: 8, src: '8.jpg' },
  { id: 9, src: '9.jpg' },
  { id: 10, src: '10.jpg' },
  { id: 11, src: '11.jpg' },
  { id: 12, src: '12.jpg' },
  { id: 13, src: '13.jpg' },
  { id: 14, src: '14.jpg' },
  { id: 15, src: '15.jpg' },
  { id: 16, src: '16.jpg' },
  { id: 17, src: '17.jpg' },
  { id: 18, src: '18.jpg' },
  { id: 19, src: '19.jpg' },
  { id: 20, src: '20.jpg' },
  { id: 21, src: '21.jpg' },
])

const selectedTheme = ref(themes[0].id)

// Store
const portal = usePortalStore()
selectedTheme.value = portal.backgroundTheme!



const close = () => {
  emit('update:theme')
}

const onClickSave = () => {
  close()
  selectTheme(selectedTheme.value)
}

// テーマを保存する
const selectTheme = (selectTheme: number) => {
  const req: ApiIF.UpdateUserRequest = {
    userId: StoreHelper.getUser().userId,
    themeSettingId: selectTheme,
  }
  const backupTheme = portal.getBackgroundTheme!
  portal.$patch({
    backgroundTheme: selectTheme,
  })

  ApiHelper.updateUser(req).catch((err) => {
    portal.$patch({
      backgroundTheme: backupTheme,
    })

    handleErrors(err)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_rb = _resolveComponent("rb")!

  return (__props.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(SlotModal, {
          keyboard: false,
          icon: require('@/assets/image/navi/navi_theme.svg'),
          onClose: close
        }, {
          title: _withCtx(() => [
            _createElementVNode("p", null, [
              _hoisted_2,
              _createElementVNode("ruby", null, [
                _createVNode(_component_rb, null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _hoisted_5,
                _hoisted_6
              ]),
              _hoisted_7
            ])
          ]),
          actionArea: _withCtx(() => [
            _createElementVNode("div", { onClick: onClickSave }, [
              _createVNode(AnimationPushToShadow, {
                tag: "button",
                backgroundColor: "#fdd400",
                shadowColor: "#ff7600",
                shadowX: "8px",
                shadowY: "8px",
                rounded: "pill",
                class: "themeSelect__button"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themes), (theme) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "themeSelect__list",
                  key: `theme-row-${theme.id}`
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: `theme-${theme.id}`,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTheme).value = $event)),
                    type: "radio",
                    name: "theme",
                    value: theme.id,
                    class: "themeSelect__input"
                  }, null, 8, _hoisted_9), [
                    [_vModelRadio, selectedTheme.value]
                  ]),
                  _createElementVNode("label", {
                    for: `theme-${theme.id}`,
                    class: "themeSelect__img"
                  }, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(AppImage, {
                        src: 
                  require(`@/assets/image/background_theme/thumbnail/${theme.src}`)
                ,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ], 8, _hoisted_10)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["icon"])
      ]))
    : _createCommentVNode("", true)
}
}

})